/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { magazineAction } from "@redux/modules";
import moment from 'moment';
import AccordionContext from 'react-bootstrap/AccordionContext';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import PagePagination from "@components/PagePagination";

import { NavLink } from 'react-router-dom';

// Header - Footer
import Header from '../Layout/Header';
import Footer from '../Layout/Footer';

// Styles
import "./styles.scss";

const Magazine = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [totalPages, setTotalPages] = useState(0);

  const magazineList = useSelector((store) => store.magazine.magazineList);
  const magazineCategoryList = useSelector(
    (store) => store.magazine.magazineCategoryList
  );

  const [selectedCategory, setSelectedCategory] = useState(0);
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        await Promise.all([
          dispatch(magazineAction.getArticleList("MAGAZINE", currentPage, pageSize)),
          dispatch(magazineAction.getArticleCategoryList("MAGAZINE"))
        ]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
    return () => {};
  }, [dispatch]);

  useEffect(() => {
    if (magazineList) {
      setTotalPages(magazineList.totalPages);
    }
  }, [magazineList]);

  const handleClickCategoryItem = (e, categoryId) => {
    setSelectedCategory(categoryId);
    setSelectedSubCategory(0);
    setCurrentPage(0);
    dispatch(magazineAction.getMagazineCategoryById("MAGAZINE", categoryId, 0, pageSize));
  };

  const handleSubCategoryClick = (e, subCategoryId) => {
    e.preventDefault();
    setSelectedSubCategory(subCategoryId);
    setSelectedCategory(0);
    setCurrentPage(0);
    
    if (subCategoryId === 0) {
      dispatch(magazineAction.getArticleList("MAGAZINE", 0, pageSize));
    } else {
      dispatch(
        magazineAction.getMagazineSubCategoryById("MAGAZINE", subCategoryId, 0, pageSize)
      );
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    if (selectedCategory) {
      dispatch(magazineAction.getMagazineCategoryById("MAGAZINE", selectedCategory, page, pageSize));
    } else if (selectedSubCategory) {
      dispatch(magazineAction.getMagazineSubCategoryById("MAGAZINE", selectedSubCategory, page, pageSize));
    } else {
      dispatch(magazineAction.getArticleList("MAGAZINE", page, pageSize));
    }
  };

  const ContextAwareToggle = ({ children, eventKey, callback }) => {
    const currentEventKey = useContext(AccordionContext);

    const decoratedOnClick = useAccordionToggle(eventKey, () => {
      callback && callback(eventKey);

      if (currentEventKey === eventKey) {
        setActiveAccordion(null);
        dispatch(magazineAction.getArticleList("MAGAZINE"));
      } else {
        setActiveAccordion(eventKey);
        handleClickCategoryItem(null, eventKey);
      }
    });

    const isCurrentEventKey = currentEventKey === eventKey;

    return (
      <button
        type="button"
        className={`btn btn-link ${selectedCategory === eventKey ? "text-green" : ""}`}
        onClick={decoratedOnClick}
      >
        {children}{" "}
        {isCurrentEventKey ? (
          <span className="accordion-button-item active"></span>
        ) : (
          <span className="accordion-button-item"></span>
        )}
      </button>
    );
  };

  const decodeHtml = (html) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  return (
    <div className="page-container">
      <Header />

      <main>
        <section className="bg-blue py-5 mb-sm-5 mb-3 d-lg-block d-none">
          <div className="container">
            <div className="d-lg-flex d-none text-white small mb-4 opacity-50">
              <NavLink
                to="/home"
                className="text-white text-decoration-none me-3"
              >
                Anasayfa
              </NavLink>
              <span className="me-3">»</span>
              {/* <span className="me-3">Bizim Dünya</span>
              <span className="me-3">»</span> */}
              <span>Blog</span>
            </div>
          </div>
        </section>

        <section className="mb-sm-10 mb-5 mt-lg-0 mt-sm-5 mt-3">
          <div className="container">
            <div className="row gy-0">
              <div className="col-xl-3 col-lg-4 order-1">
                <div className="ps-lg-3 ps-0">
                  <div className="offcanvas offcanvas-start offcanvas-responsive-lg">
                    <div className="offcanvas-header">
                      <h5 className="offcanvas-title">Kategoriler</h5>
                      <button
                        type="button"
                        className="btn-close text-reset"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="offcanvas-body">
                      <h4 className="mb-4 d-lg-block d-none">Kategoriler</h4>
                      {isLoading ? (
                        <div className="text-center py-4">
                          <div
                            className="spinner-border text-primary"
                            role="status"
                          >
                            <span className="visually-hidden">
                              Yükleniyor...
                            </span>
                          </div>
                        </div>
                      ) : (
                        <Accordion activeKey={activeAccordion} className="pb-4">
                          <Card className="active">
                            <Card.Header>
                              <a
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setSelectedCategory(0);
                                  setActiveAccordion(null);
                                  dispatch(
                                    magazineAction.getArticleList("MAGAZINE")
                                  );
                                }}
                                className={
                                  selectedCategory === 0
                                    ? "btn btn-link text-decoration-none active"
                                    : "btn btn-link text-decoration-none"
                                }
                              >
                                Tüm Makaleler
                              </a>
                            </Card.Header>
                          </Card>

                          {magazineCategoryList?.content?.length > 0 ? (
                            magazineCategoryList.content
                              .filter((item) => item.active === true)
                              .map((item) => (
                                <Card key={item.id}>
                                  <Card.Header>
                                    <ContextAwareToggle eventKey={item.id}>
                                      {item.name}
                                    </ContextAwareToggle>
                                  </Card.Header>
                                  <Accordion.Collapse eventKey={item.id}>
                                    <Card.Body>
                                      {item.topicSubCategoryList?.length >
                                        0 && (
                                        <ul className="accordion-sub-menu">
                                          {item.topicSubCategoryList?.length >
                                            0 &&
                                            item.topicSubCategoryList
                                              .filter(
                                                (subItem) =>
                                                  subItem.active === true
                                              )
                                              .map((subItem) => (
                                                <li key={subItem.id}>
                                                  <a
                                                    href="#"
                                                    onClick={(e) =>
                                                      handleSubCategoryClick(
                                                        e,
                                                        subItem.id
                                                      )
                                                    }
                                                    className={
                                                      selectedSubCategory ===
                                                      subItem.id
                                                        ? "text-green"
                                                        : ""
                                                    }
                                                  >
                                                    {subItem.name}
                                                  </a>
                                                </li>
                                              ))}
                                        </ul>
                                      )}
                                    </Card.Body>
                                  </Accordion.Collapse>
                                </Card>
                              ))
                          ) : (
                            <div className="text-center">
                              <p>Kategori bulunamadı</p>
                            </div>
                          )}
                        </Accordion>
                      )}
                    </div>
                  </div>
                  <a
                    href=".offcanvas"
                    className="btn btn-blue-light text-white rounded-circle p-0 d-flex align-items-center justify-content-center shadow position-fixed bottom-0 end-0 mb-3 me-3"
                    data-bs-toggle="offcanvas"
                  >
                    <i className="fas fa-list-alt"></i>
                  </a>
                </div>
              </div>

              <div className="col-xl-9 col-lg-8 order-0">
                {isLoading ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Yükleniyor...</span>
                    </div>
                  </div>
                ) : magazineList?.content?.length > 0 ? (
                  <>
                    {magazineList.content.slice(0, 1).map((item) => (
                      <NavLink
                        to={`/magazine/${item.id}`}
                        className="d-block overflow-hidden position-relative rounded-3 mb-sm-5 mb-3 mt-lg-n8 mt-0"
                        key={item.id}
                      >
                        {item.articleContentDTOList &&
                        item.articleContentDTOList.length > 0 &&
                        item.articleContentDTOList[0].baseAddress ? (
                          <img
                            src={item?.articleContentDTOList[0]?.baseAddress}
                            alt={item.name}
                            className="w-100 img-cover"
                            style={{ width: "960px", height: "480px" }}
                          />
                        ) : (
                          <div
                            style={{ height: "480px", background: "#ddd" }}
                          ></div>
                        )}

                        <div className="position-absolute bottom-0 w-100 p-sm-5 p-4 overlay">
                          <span className="d-block small text-white mb-3">
                            {moment(item.dateCreated).format(
                              "DD.MM.YYYY - HH:mm"
                            )}{" "}
                            <span className="ms-3">#{}</span>
                          </span>
                          <h2 className="mb-0 lh-base text-white">
                            {item.name}
                          </h2>
                        </div>
                      </NavLink>
                    ))}

                    <div className="mb-sm-n4 mb-n2">
                      {magazineList.content.slice(1, 9999).map((item) => (
                        <NavLink
                          to={`/magazine/${item.id}`}
                          className="d-block overflow-hidden position-relative rounded-3 shadow text-decoration-none text-reset mb-sm-4 mb-2"
                          key={item.id}
                        >
                          <div className="row g-0 align-items-stretch">
                            <div className="col-md-5">
                              {item.articleContentDTOList &&
                              item.articleContentDTOList.length > 0 &&
                              item.articleContentDTOList[0].baseAddress ? (
                                <img
                                  src={
                                    item?.articleContentDTOList[0]?.baseAddress
                                  }
                                  alt={item.name}
                                  className="img-cover w-100 h-100"
                                  style={{ width: "300px", height: "200px" }}
                                />
                              ) : (
                                <div
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    background: "#ddd",
                                  }}
                                ></div>
                              )}
                            </div>
                            <div className="col-md-7 px-sm-5 px-4 py-4 align-self-center">
                              <span className="d-block text-blue small mb-1">
                                {moment(item.dateCreated).format(
                                  "DD.MM.YYYY - HH:mm"
                                )}
                              </span>
                              <h5 className="mb-3 lh-base">{item.name}</h5>
                              <p className="fw-light small mb-0 d-xl-block d-none">
                                {decodeHtml(
                                  item.description.replace(
                                    /<\/?[^>]+(>|$)/g,
                                    ""
                                  )
                                ).slice(0, 100)}
                                ...
                              </p>
                              <span className="d-block text-blue small mt-4">
                                {item.topicSubCategoryName &&
                                  `#${item.topicSubCategoryName}`}
                              </span>
                            </div>
                          </div>
                        </NavLink>
                      ))}
                    </div>

                    {/* Pagination */}
                    {magazineList && magazineList.totalElements > 0 && (
                      <div className="pt-5">
                        <PagePagination
                          currentPage={currentPage}
                          totalPages={totalPages}
                          onPageChange={handlePageChange}
                        />
                      </div>
                    )}
                    {/* End Pagination */}
                  </>
                ) : (
                  <div className="text-center py-5">
                    <p>Seçili Kategoride makale bulunamadı</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Magazine;
